var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecure2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.63,
    height: 16,
    viewBox: "0 0 11.63 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9,6.88h-.47V4.62a4.62,4.62,0,0,0-9.24,0V6.88H.73A.73.73,0,0,0,0,7.61H0v7.66A.73.73,0,0,0,.73,16H10.9a.73.73,0,0,0,.73-.73h0V7.61a.73.73,0,0,0-.73-.73Zm-4.36,5v.92a.73.73,0,0,1-1.45,0v-.92a1.34,1.34,0,1,1,1.85-.4A1.27,1.27,0,0,1,6.54,11.85ZM9,6.88H2.65V4.62A3.17,3.17,0,1,1,9,4.62H9Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure2);
export default __webpack_public_path__ + "static/media/secure-2.2929a3f1f14e55a5231f893001a851cd.svg";
export { ForwardRef as ReactComponent };